<template>
  <v-card class="pa-4" elevation="0">
    <div id="page1">
      <div class="header">
        {{ $t('A instituição') }}
        <br />
        {{ institutionName }}
        <br />
        A/C: {{ toCareUser.name }}
      </div>

      <div class="pa-2">
        <br />
        <br />

        <p>
          {{ $t('ASSUNTO: Relatório de Desempenho') }}
        </p>

        <br />

        <p>
          {{
            $t(
              'Vimos por meio deste, formalizar a entrega do Relatório de Desempenho das atividades desempenhadas pelo setor durante o período na instituição'
            )
          }}
          {{ institutionName }}.
        </p>

        <br />

        <p>
          {{
            $t(
              'Para elaboração do mesmo, utilizamos os dados de apoio e indicadores gerados pelo software FixSystem - Software de gestão. Outros indicadores, listagens especificas ou maiores informações sobre o parque de equipamentos poderão ser solicitados pela administração se necessário.'
            )
          }}
        </p>

        <br />

        <p>
          {{
            $t(
              'A equipe permanece a inteira disposição e disponibiliza o contato dos responsáveis técnicos abaixo para o caso de qualquer dúvida:'
            )
          }}
        </p>

        <br />
        <br />

        <div class="d-flex justify-space-around">
          <div class="text-center">
            {{ user.name }}
            <br />
            {{ $t(offices[institution.userOffice]) }}
            <br />
            {{ user.cellPhoneNumber }}
          </div>

          <div class="text-center">
            {{ reviser.name }}
            <br />
            {{ reviser.userOffice }}
            <br />
            {{ reviser.cellPhoneNumber }}
          </div>
        </div>

        <br />
      </div>
    </div>

    <v-divider class="ma-4"></v-divider>

    <div id="page2">
      <div class="pa-2">
        <h2 class="primary--text my-4">{{ $t('Objetivos') }}:</h2>

        <p>
          {{
            'O presente relatório tem por objetivo apresentar os indicadores de desempenho, bem como as principais atividades realizadas pelo setor na instituição'
          }}
          {{ institutionName }}.
        </p>

        <br />

        <h2 class="primary--text my-4">
          {{ $t('Principais eventos do período') }}:
        </h2>

        <p class="text-start" style="white-space: pre-wrap">
          {{ lastEvents }}
        </p>

        <br />

        <h2 class="primary--text my-4">
          {{ $t('Eventos previstos para o próximo mês') }}:
        </h2>

        <p class="text-start" style="white-space: pre-wrap">
          {{ nextEvents }}
        </p>
      </div>
    </div>

    <v-divider class="ma-4"></v-divider>

    <div class="page3">
      <div class="pa-2">
        <h2 class="primary--text">{{ $t('Indicadores de Desempenho') }}:</h2>
        <br />

        <p>
          {{
            $t(
              'O sistema de gestão da qualidade para o presente serviço de Engenharia Clínica atualmente acompanha e supervisiona os seguintes indicadores de desempenho'
            )
          }}:
        </p>

        <br />

        <div
          class="d-flex align-center primary--text mt-4 mb-2"
          v-if="selection.filter((x) => x.includes('1.')).length > 0"
        >
          <h2 class="mr-2">1.0</h2>
          <span style="font-size: 18px">
            {{ $t('Indicadores quantitativos') }}
          </span>
        </div>

        <ul>
          <li
            v-for="select in selection.filter((x) => x.includes('1.'))"
            :key="select"
          >
            <div class="d-flex align-center">
              <h3 class="mr-2">1.{{ chartsValues[select] }}</h3>
              <span> {{ $t(select.split('-')[1]) }} </span>
            </div>
          </li>
        </ul>

        <br v-if="selection.filter((x) => x.includes('1.')).length > 0" />

        <div
          class="d-flex align-center primary--text mt-4 mb-2"
          v-if="selection.filter((x) => x.includes('2.')).length > 0"
        >
          <h2 class="mr-2">2.0</h2>
          <span style="font-size: 18px">
            {{ $t('Indicadores de tempo médio') }}
          </span>
        </div>

        <ul>
          <li
            v-for="select in selection.filter((x) => x.includes('2.'))"
            :key="select"
          >
            <div class="d-flex align-center">
              <h3 class="mr-2">2.{{ chartsValues[select] }}</h3>
              <span> {{ $t(select.split('-')[1]) }} </span>
            </div>
          </li>
        </ul>

        <br v-if="selection.filter((x) => x.includes('2.')).length > 0" />

        <div
          class="d-flex align-center primary--text mt-4 mb-2"
          v-if="selection.filter((x) => x.includes('3.')).length > 0"
        >
          <h2 class="mr-2">3.0</h2>
          <span style="font-size: 18px">
            {{ $t('Indicadores de custos de manutenção') }}
          </span>
        </div>

        <ul>
          <li
            v-for="select in selection.filter((x) => x.includes('3.'))"
            :key="select"
          >
            <div class="d-flex align-center">
              <h3 class="mr-2">3.{{ chartsValues[select] }}</h3>
              <span> {{ $t(select.split('-')[1]) }} </span>
            </div>
          </li>
        </ul>

        <br v-if="selection.filter((x) => x.includes('3.')).length > 0" />

        <div
          class="d-flex align-center primary--text mt-4 mb-2"
          v-if="selection.filter((x) => x.includes('4.')).length > 0"
        >
          <h2 class="mr-2">4.0</h2>
          <span style="font-size: 18px">
            {{ $t('Indicadores de controle de qualidade') }}
          </span>
        </div>

        <ul>
          <li
            v-for="select in selection.filter((x) => x.includes('4.'))"
            :key="select"
          >
            <div class="d-flex align-center">
              <h3 class="mr-2">4.{{ chartsValues[select] }}</h3>
              <span> {{ $t(select.split('-')[1]) }} </span>
            </div>
          </li>
        </ul>

        <br v-if="selection.filter((x) => x.includes('4.')).length > 0" />
      </div>
    </div>

    <v-divider class="ma-4"></v-divider>

    <div
      class="page4 my-4"
      v-if="selection.filter((x) => x.includes('1.')).length > 0"
    >
      <div class="header">
        <div class="d-flex align-center ml-2" style="font-size: 16px">
          <h3 class="mr-2">1.0</h3>
          {{ $t('Indicadores quantitativos') }}
        </div>
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.1 - Equipamentos por setor')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.1 - Equipamentos por setor'] }}
          </h3>
          {{ $t('Equipamentos por setor') }}
        </div>
        <EquipmentBySectorChart
          :filterProp="
            chartInfos.find((x) => x.chart == '1.1 - Equipamentos por setor')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '1.1 - Equipamentos por setor')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.2 - Equipamentos Desativados no Período')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.2 - Equipamentos Desativados no Período'] }}
          </h3>
          {{ $t('Equipamentos Desativados no Período') }}
        </div>
        <AlienatedEquip
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '1.2 - Equipamentos Desativados no Período'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '1.2 - Equipamentos Desativados no Período'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.3 - Solicitações por setor')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.3 - Solicitações por setor'] }}
          </h3>
          {{ $t('Solicitações por setor') }}
        </div>
        <RequestBySector
          :filterProp="
            chartInfos.find((x) => x.chart == '1.3 - Solicitações por setor')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '1.3 - Solicitações por setor')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.4 - Equipamentos Parados x Tipo de Pendencia')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{
              chartsValues['1.4 - Equipamentos Parados x Tipo de Pendencia']
            }}
          </h3>
          {{ $t('Equipamentos Parados x Tipo de Pendencia') }}
        </div>
        <StoppedEquipPendingType
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '1.4 - Equipamentos Parados x Tipo de Pendencia'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '1.4 - Equipamentos Parados x Tipo de Pendencia'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.5 - Top 5 equipamentos com mais falhas')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.5 - Top 5 equipamentos com mais falhas'] }}
          </h3>
          {{ $t('Top 5 equipamentos com mais falhas') }}
        </div>
        <TopFiveEquipFailures
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '1.5 - Top 5 equipamentos com mais falhas'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '1.5 - Top 5 equipamentos com mais falhas'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.6 - Prevalência solução defeito')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.6 - Prevalência solução defeito'] }}
          </h3>
          {{ $t('Prevalência solução defeito') }}
        </div>
        <DefectSolutionPrev
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '1.6 - Prevalência solução defeito'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '1.6 - Prevalência solução defeito'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.7 - Serviços solicitados x concluídos - Período')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{
              chartsValues['1.7 - Serviços solicitados x concluídos - Período']
            }}
          </h3>
          {{ $t('Serviços solicitados x concluídos - Período') }}
        </div>
        <SolicitedVConcluded
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart == '1.7 - Serviços solicitados x concluídos - Período'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart == '1.7 - Serviços solicitados x concluídos - Período'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.8 - Corretivas solicitadas x executadas - Acumulado')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{
              chartsValues[
                '1.8 - Corretivas solicitadas x executadas - Acumulado'
              ]
            }}
          </h3>
          {{ $t('Corretivas solicitadas x executadas - Acumulado') }}
        </div>
        <CorrectiveScheXExec
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart ==
                '1.8 - Corretivas solicitadas x executadas - Acumulado'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart ==
                '1.8 - Corretivas solicitadas x executadas - Acumulado'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.9 - Resolutividade interna')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.9 - Resolutividade interna'] }}
          </h3>
          {{ $t('Resolutividade Interna') }}
        </div>
        <InternalResolvability
          :filterProp="
            chartInfos.find((x) => x.chart == '1.9 - Resolutividade interna')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '1.9 - Resolutividade interna')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.10 - Preventiva x Corretiva')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.10 - Preventiva x Corretiva'] }}
          </h3>
          {{ $t('Preventiva x Corretiva') }}
        </div>
        <PreventiveXCorrective
          :filterProp="
            chartInfos.find((x) => x.chart == '1.10 - Preventiva x Corretiva')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '1.10 - Preventiva x Corretiva')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.11 - Preventivas agendadas x executadas - Acumulado')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{
              chartsValues[
                '1.11 - Preventivas agendadas x executadas - Acumulado'
              ]
            }}
          </h3>
          {{ $t('Preventivas Agendadas x Executas - Acumulado') }}
        </div>
        <PreventiveSchedXExec
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart ==
                '1.11 - Preventivas agendadas x executadas - Acumulado'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart ==
                '1.11 - Preventivas agendadas x executadas - Acumulado'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.12 - Calibrações agendadas x executadas')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.12 - Calibrações agendadas x executadas'] }}
          </h3>
          {{ $t('Calibrações agendadas x executadas - Acumulado') }}
        </div>
        <CalibSchedXExec
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '1.12 - Calibrações agendadas x executadas'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '1.12 - Calibrações agendadas x executadas'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes(
              '1.13 - Segurança elétrica agendada x executada - acumulado'
            )
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{
              chartsValues[
                '1.13 - Segurança elétrica agendada x executada - acumulado'
              ]
            }}
          </h3>
          {{ $t('Segurança Elétrica agendada x executada - Acumulado') }}
        </div>
        <EletricSecSchedXExec
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart ==
                '1.13 - Segurança elétrica agendada x executada - acumulado'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart ==
                '1.13 - Segurança elétrica agendada x executada - acumulado'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('1.14 - Histórico de migração de equipamentos')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.14 - Histórico de migração de equipamentos'] }}
          </h3>
          {{ $t('Histórico de migração de equipamentos') }}
        </div>
        <HistoricalMigration
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '1.14 - Histórico de migração de equipamentos'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '1.14 - Histórico de migração de equipamentos'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          institution.departmentTypes.includes(1) &&
          chartInfos
            .map((x) => x.chart)
            .includes('1.15 - Solicitações por Oficina')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            1.{{ chartsValues['1.15 - Solicitações por Oficina'] }}
          </h3>
          {{ $t('Solicitações por Oficina') }}
        </div>
        <OrderByWorkshop
          :filterProp="
            chartInfos.find((x) => x.chart == '1.15 - Solicitações por Oficina')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '1.15 - Solicitações por Oficina')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>
    </div>

    <v-divider
      class="ma-4"
      v-if="selection.filter((x) => x.includes('1.')).length > 0"
    ></v-divider>

    <div
      class="page5 my-4"
      v-if="selection.filter((x) => x.includes('2.')).length > 0"
    >
      <div class="header">
        <div class="d-flex align-center ml-2" style="font-size: 16px">
          <h3 class="mr-2">2.0</h3>
          {{ $t('Indicadores de tempo médio') }}
        </div>
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.1 - Tempo de máquina parada')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.1 - Tempo de máquina parada'] }}
          </h3>
          {{ $t('Tempo de máquina parada') }}
        </div>
        <StoppedMachine
          :institution="institution"
          :filterProp="
            chartInfos.find((x) => x.chart == '2.1 - Tempo de máquina parada')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '2.1 - Tempo de máquina parada')
              .review
          "
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.2 - Tempo médio entre falhas por equipamento padrão')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{
              chartsValues[
                '2.2 - Tempo médio entre falhas por equipamento padrão'
              ]
            }}
          </h3>
          {{ $t('Tempo médio entre falhas por equipamento padrão') }}
        </div>
        <StandEquipFailures
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart ==
                '2.2 - Tempo médio entre falhas por equipamento padrão'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart ==
                '2.2 - Tempo médio entre falhas por equipamento padrão'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.3 - Tempo médio entre falhas por equipamento')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{
              chartsValues['2.3 - Tempo médio entre falhas por equipamento']
            }}
          </h3>
          {{ $t('Tempo médio entre falhas por equipamento') }}
        </div>
        <TotalServiceTime
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.3 - Tempo médio entre falhas por equipamento'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.3 - Tempo médio entre falhas por equipamento'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.4 - Atendimento x Previsão atendimento')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.4 - Atendimento x Previsão atendimento'] }}
          </h3>
          {{ $t('Atendimento x Previsão atendimento') }}
        </div>
        <ServiceForecast
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.4 - Atendimento x Previsão atendimento'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.4 - Atendimento x Previsão atendimento'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.5 - Chamados atendidos no prazo')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.5 - Chamados atendidos no prazo'] }}
          </h3>
          {{ $t('Chamados Corretivos Atendidos no Prazo') }}
        </div>
        <CallsAnsweredChart
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.5 - Chamados atendidos no prazo'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.5 - Chamados atendidos no prazo'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.6 - Resolução x Previsão resolução')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.6 - Resolução x Previsão resolução'] }}
          </h3>
          {{ $t('Resolução x Previsão resolução') }}
        </div>
        <ResolutionForecast
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.6 - Resolução x Previsão resolução'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.6 - Resolução x Previsão resolução'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.7 - Chamados resolvidos no prazo')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.7 - Chamados resolvidos no prazo'] }}
          </h3>
          {{ $t('Chamados Corretivos Resolvidos no Prazo') }}
        </div>
        <CallsResolvedChart
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.8 - Tempo de atendimento interno por setor')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.8 - Tempo de atendimento interno por setor'] }}
          </h3>
          {{ $t('Tempo de Atendimento Interno por Setor') }}
        </div>
        <ServiceTimeDepartment
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.8 - Tempo de atendimento interno por setor'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.8 - Tempo de atendimento interno por setor'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.9 - Tempo de atendimento interno por criticidade')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{
              chartsValues['2.9 - Tempo de atendimento interno por criticidade']
            }}
          </h3>
          {{ $t('Tempo de atendimento interno por criticidade') }}
        </div>
        <ServiceTimeCrit
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart == '2.9 - Tempo de atendimento interno por criticidade'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart == '2.9 - Tempo de atendimento interno por criticidade'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="chartInfos.map((x) => x.chart).includes('2.10 - Tempo produtivo')"
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">2.{{ chartsValues['2.10 - Tempo produtivo'] }}</h3>
          {{ $t('Tempo Produtivo') }}
        </div>
        <ProdTime
          :filterProp="
            chartInfos.find((x) => x.chart == '2.10 - Tempo produtivo')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '2.10 - Tempo produtivo').review
          "
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.11 - Tempo produtivo por setor')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.11 - Tempo produtivo por setor'] }}
          </h3>
          {{ $t('Tempo produtivo por setor') }}
        </div>
        <ProdTimeSector
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.11 - Tempo produtivo por setor'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.11 - Tempo produtivo por setor'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.12 - Tempo médio de resolução interna por criticidade')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{
              chartsValues[
                '2.12 - Tempo médio de resolução interna por criticidade'
              ]
            }}
          </h3>
          {{ $t('Tempo médio de resolução interna por criticidade') }}
        </div>
        <ResolutionTimeCrit
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart ==
                '2.12 - Tempo médio de resolução interna por criticidade'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart ==
                '2.12 - Tempo médio de resolução interna por criticidade'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
          :standardEquipments="standardEquipments"
        />
      </div>
    </div>

    <v-divider
      class="ma-4"
      v-if="selection.filter((x) => x.includes('2.')).length > 0"
    ></v-divider>

    <div
      class="page6 my-4"
      v-if="selection.filter((x) => x.includes('3.')).length > 0"
    >
      <div class="header">
        <div class="d-flex align-center ml-2" style="font-size: 16px">
          <h3 class="mr-2">3.0</h3>
          {{ $t('Indicadores de custos de manutenção') }}
        </div>
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('3.1 - Custos por peça avulsa')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            3.{{ chartsValues['3.1 - Custos por peça avulsa'] }}
          </h3>
          {{ $t('Custos por Peça Avulsa') }}
        </div>
        <CostPerPiece
          :filterProp="
            chartInfos.find((x) => x.chart == '3.1 - Custos por peça avulsa')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '3.1 - Custos por peça avulsa')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('3.2 - Custos por serviço avulso')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            3.{{ chartsValues['3.2 - Custos por serviço avulso'] }}
          </h3>
          {{ $t('Custos por serviço avulso') }}
        </div>
        <CostPerService
          :filterProp="
            chartInfos.find((x) => x.chart == '3.2 - Custos por serviço avulso')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '3.2 - Custos por serviço avulso')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="chartInfos.map((x) => x.chart).includes('3.3 - Custo por setor')"
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">3.{{ chartsValues['3.3 - Custo por setor'] }}</h3>
          {{ $t('Custos por setor') }}
        </div>
        <CostPerSector
          :filterProp="
            chartInfos.find((x) => x.chart == '3.3 - Custo por setor')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '3.3 - Custo por setor').review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('3.4 - Custo por ID equipamento')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            3.{{ chartsValues['3.4 - Custo por ID equipamento'] }}
          </h3>
          {{ $t('Custos por ID de equipamento') }}
        </div>
        <CostPerId
          :filterProp="
            chartInfos.find((x) => x.chart == '3.4 - Custo por ID equipamento')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '3.4 - Custo por ID equipamento')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="chartInfos.map((x) => x.chart).includes('3.5 - Custo evitado')"
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">3.{{ chartsValues['3.5 - Custo evitado'] }}</h3>
          {{ $t('Custo evitado') }}
        </div>
        <AvoidedCosts
          :filterProp="chartInfos.find((x) => x.chart == '3.5 - Custo evitado')"
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '3.5 - Custo evitado').review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>
    </div>

    <v-divider
      class="ma-4"
      v-if="selection.filter((x) => x.includes('3.')).length > 0"
    ></v-divider>

    <div
      class="page7 my-4"
      v-if="selection.filter((x) => x.includes('4.')).length > 0"
    >
      <div class="header">
        <div class="d-flex align-center ml-2" style="font-size: 16px">
          <h3 class="mr-2">4.0</h3>
          {{ $t('Indicadores de controle de qualidade') }}
        </div>
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('4.1 - Notas das avaliações O.S.')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            4.{{ chartsValues['4.1 - Notas das avaliações O.S.'] }}
          </h3>
          {{ $t('Notas das avaliações de Chamados') }}
        </div>
        <OrderRatings
          :filterProp="
            chartInfos.find((x) => x.chart == '4.1 - Notas das avaliações O.S.')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '4.1 - Notas das avaliações O.S.')
              .review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos.map((x) => x.chart).includes('4.2 - Ranking fornecedor')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">4.{{ chartsValues['4.2 - Ranking fornecedor'] }}</h3>
          {{ $t('Ranking fornecedor') }}
        </div>
        <RankingSupplier
          :filterProp="
            chartInfos.find((x) => x.chart == '4.2 - Ranking fornecedor')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '4.2 - Ranking fornecedor').review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('4.3 - Adesão ao módulo de chamados')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            4.{{ chartsValues['4.3 - Adesão ao módulo de chamados'] }}
          </h3>
          {{ $t('Adesão ao módulo de chamados') }}
        </div>
        <AdhesionCalledMod
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
            ).review
          "
          :institution="institution"
          :unidades="unidades"
        />
      </div>
    </div>

    <v-card-actions class="justify-space-between">
      <v-btn text @click="$emit('back')">
        <v-icon>mdi-chevron-left</v-icon>
        {{ $t('Voltar') }}
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn text @click="submit" :loading="loading">
        {{ $t('Gerar relatório') }}
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import GeneralService from '../../../../../../services/GeneralService'

import EquipmentBySectorChart from './charts/quantitative/equipmentBySector.vue'
import RequestBySector from './charts/quantitative/requestBySector.vue'
import TopFiveEquipFailures from './charts/quantitative/topFiveEquipFailures.vue'
import DefectSolutionPrev from './charts/quantitative/defectSolutionPrev.vue'
import SolicitedVConcluded from './charts/quantitative/solicitedVConcluded.vue'
import CorrectiveScheXExec from './charts/quantitative/correctiveSchedXExec.vue'
import InternalResolvability from './charts/quantitative/internalResolvability.vue'
import PreventiveXCorrective from './charts/quantitative/preventiveXCorrective.vue'
import PreventiveSchedXExec from './charts/quantitative/preventiveSchedxExec.vue'
import CalibSchedXExec from './charts/quantitative/calibSchedXExec.vue'
import EletricSecSchedXExec from './charts/quantitative/eletricSecSchedXExec.vue'
import AlienatedEquip from './charts/quantitative/alienatedEquip.vue'
import HistoricalMigration from './charts/quantitative/historicalMigration.vue'
import StoppedEquipPendingType from './charts/quantitative/stoppedEquipPendingType.vue'
import OrderByWorkshop from './charts/quantitative/orderByWorkshop.vue'

import StoppedMachine from './charts/time/stoppedMachine.vue'
import StandEquipFailures from './charts/time/standEquipFailures.vue'
import TotalServiceTime from './charts/time/totalServiceTime.vue'
import ServiceTimeDepartment from './charts/time/serviceTimeDepartment.vue'
import ServiceTimeCrit from './charts/time/serviceTimeCrit.vue'
import ProdTimeSector from './charts/time/prodTimeSector.vue'
import ProdTime from './charts/time/prodTime.vue'
import ResolutionTimeCrit from './charts/time/resolutionTimeCrit.vue'

import CostPerPiece from './charts/costs/costPerPiece.vue'
import CostPerService from './charts/costs/costPerService.vue'
import CostPerSector from './charts/costs/costPerSector.vue'
import CostPerId from './charts/costs/costPerId.vue'
import AvoidedCosts from './charts/costs/avoidedCosts.vue'

import OrderRatings from './charts/control/orderRatings.vue'
import RankingSupplier from './charts/control/rankingSupplier.vue'
import AdhesionCalledMod from './charts/control/adhesionCalledMod.vue'
import ServiceForecast from './charts/control/serviceForecast.vue'
import CallsAnsweredChart from './charts/control/CallsAnsweredChart.vue'
import ResolutionForecast from './charts/control/resolutionForecast.vue'
import CallsResolvedChart from './charts/control/CallsResolvedChart.vue'

export default {
  name: 'GenerateReportResult',

  props: {
    selection: Array,
    lastEvents: String,
    nextEvents: String,
    reviser: Object,
    toCareUser: Object,
    chartInfos: Array,
    unidades: Array,
    institutionName: String,
    link: String,
    isEditing: Boolean,
    reportId: String,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.user = JSON.parse(localStorage.getItem('user'))

    this.chartInfos
      .map((x) => x.chart)
      .filter((x) => x.includes('1.'))
      .sort(
        new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
          .compare
      )
      .forEach((element, i) => {
        this.chartsValues[element] = i + 1
      })

    this.chartInfos
      .map((x) => x.chart)
      .filter((x) => x.includes('2.'))
      .sort(
        new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
          .compare
      )
      .forEach((element, i) => {
        this.chartsValues[element] = i + 1
      })

    this.chartInfos
      .map((x) => x.chart)
      .filter((x) => x.includes('3.'))
      .sort(
        new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
          .compare
      )
      .forEach((element, i) => {
        this.chartsValues[element] = i + 1
      })

    this.chartInfos
      .map((x) => x.chart)
      .filter((x) => x.includes('4.'))
      .sort(
        new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
          .compare
      )
      .forEach((element, i) => {
        this.chartsValues[element] = i + 1
      })
    await this.getStandardEquipments()
  },

  data() {
    return {
      user: {},
      apiService: new ApiService(),
      generalService: new GeneralService(),
      institution: {},
      standardEquipments: [],
      loading: false,
      chartsValues: {},
      offices: [
        'Auxiliar',
        'Coordenador',
        'Enfermeiro',
        'Engenheiro',
        'Estagiário',
        'Recepcionista',
        'Supervisor',
        'Técnico',
        'Farmacêutico',
        'Fisioterapeuta',
        'Administrativo',
        'Gerente',
        'Nutricionista',
      ],
    }
  },

  components: {
    OrderByWorkshop,
    EquipmentBySectorChart,
    RequestBySector,
    TopFiveEquipFailures,
    DefectSolutionPrev,
    SolicitedVConcluded,
    CorrectiveScheXExec,
    InternalResolvability,
    PreventiveXCorrective,
    PreventiveSchedXExec,
    CalibSchedXExec,
    EletricSecSchedXExec,
    AlienatedEquip,
    HistoricalMigration,
    StoppedEquipPendingType,
    StoppedMachine,
    StandEquipFailures,
    TotalServiceTime,
    ServiceTimeDepartment,
    ServiceTimeCrit,
    ProdTimeSector,
    ProdTime,
    ResolutionTimeCrit,
    CostPerPiece,
    CostPerService,
    CostPerSector,
    CostPerId,
    AvoidedCosts,
    OrderRatings,
    RankingSupplier,
    AdhesionCalledMod,
    ServiceForecast,
    CallsAnsweredChart,
    ResolutionForecast,
    CallsResolvedChart,
  },

  methods: {
    submit() {
      this.loading = true
      const model = {
        institutionId: this.institution.id,
        link: this.link,
        content: JSON.stringify({
          institutionName: this.institutionName,
          reviser: {
            name: this.reviser.name,
            userOffice: this.reviser.userOffice,
            cellPhoneNumber: this.reviser.cellPhoneNumber,
          },
          executionUser: {
            name: this.user.name,
            userOffice: this.institution.userOffice,
            cellPhoneNumber: this.institution.cellPhoneNumber,
          },
          toCareUser: {
            name: this.toCareUser.name,
            userOffice: this.toCareUser.userOffice,
            cellPhoneNumber: this.toCareUser.cellPhoneNumber,
          },
          lastEvents: this.lastEvents,
          nextEvents: this.nextEvents,
          chartInfos: this.chartInfos.map((x) => {
            return {
              ...x,
              data: null,
            }
          }),
        }),
      }

      let url = 'generatedReport/add'
      if (this.isEditing) {
        url = 'generatedReport/edit'
        model.id = this.reportId
      }

      this.apiService
        .post(url, model)
        .then((response) => {
          this.$toast.success('Relatório gerado com sucesso')
          window.open(`generatedReport/${this.link}`, '_blank').focus()
          this.$emit('confirm')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async getStandardEquipments() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )
    },
  },
}
</script>

<style scoped>
.header {
  padding: 10px;
  background: #0f3565;
  color: white;
  border-radius: 6px;
  border-top-right-radius: 37px;
}
</style>
